<template>
  <div class="tracking-page">
    <tracking-page-header
      title="Support calls & reasons"
      subtitle="Why patients contact support, and which booking step they were on before calling."
      :from-date="fromDate"
      :to-date="toDate"
      :loading="loading"
      :chat-filters="chatFilters"
      :page-summary="pageSummary"
      @apply="fromDate = $event.fromDate; toDate = $event.toDate; loadData()"
      @refresh="loadData"
    />

    <div class="trk-kpi-grid">
      <div class="trk-kpi"><div class="trk-kpi-label">Support contacts</div><div class="trk-kpi-value">{{ formatNumber(support.totalInteractions) }}</div></div>
      <div class="trk-kpi"><div class="trk-kpi-label">Linked to a journey</div><div class="trk-kpi-value">{{ formatNumber(support.matchedJourneys) }}</div><div class="trk-kpi-help">Matched to booking activity</div></div>
      <div class="trk-kpi"><div class="trk-kpi-label">Top reason</div><div class="trk-kpi-value" style="font-size:1.15rem">{{ topReason }}</div></div>
    </div>

    <b-row>
      <b-col md="4">
        <div class="trk-panel">
          <div class="trk-panel-head"><div><h2>Why they called</h2><p>Reason buckets</p></div></div>
          <div class="trk-panel-body">
            <table class="table trk-table mb-0" v-trk-resizable="'support-reasons'">
              <thead><tr><th>Reason</th><th>Count</th></tr></thead>
              <tbody>
                <tr v-for="row in (support.reasonBuckets || [])" :key="row.reason">
                  <td>{{ prettyReason(row.reason) }}</td>
                  <td>{{ formatNumber(row.count) }}</td>
                </tr>
                <tr v-if="!(support.reasonBuckets || []).length">
                  <td colspan="2" class="text-muted">No support data yet</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </b-col>
      <b-col md="8">
        <div class="trk-panel">
          <div class="trk-panel-head"><div><h2>Recent contacts</h2><p>Linked journeys help validate the booking drop-off</p></div></div>
          <div class="trk-panel-body p-0">
            <table class="table trk-table mb-0" v-trk-resizable="'support-contacts'">
              <thead>
                <tr>
                  <th>When</th>
                  <th>Reason</th>
                  <th>Last booking step</th>
                  <th>Journey</th>
                  <th>Summary</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in interactions" :key="row.id">
                  <td>{{ formatWhen(row.startedAt) }}</td>
                  <td>{{ prettyReason(row.reasonCategory) }}</td>
                  <td>{{ prettyStep(row.journeyStepBeforeContact) }}</td>
                  <td>
                    <router-link
                      v-if="row.sessionId"
                      :to="{ path: '/tracking/sessions/' + row.sessionId, query: { from: 'support' } }"
                    >Open</router-link>
                    <span v-else class="text-muted">Not linked</span>
                  </td>
                  <td>{{ row.redactedSummary || '-' }}</td>
                </tr>
                <tr v-if="!interactions.length">
                  <td colspan="5">
                    <div class="trk-empty">
                      <strong>No support interactions yet</strong>
                      Import call summaries here (Vonage can be connected later).
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import TrackingPageHeader from './TrackingPageHeader.vue';
import { defaultDateRange, formatNumber, prettyStep, rangeParams, formatUkDateTime } from './trackingShared';

export default {
  name: 'TrackingSupport',
  components: { TrackingPageHeader },
  data() {
    const range = defaultDateRange(7);
    return {
      fromDate: range.fromDate,
      toDate: range.toDate,
      support: {},
      interactions: [],
      loading: false
    };
  },
  computed: {
    chatFilters() {
      return rangeParams(this.fromDate, this.toDate);
    },
    pageSummary() {
      return `${this.formatNumber(this.support.totalInteractions)} support contacts; top reason: ${this.topReason}`;
    },
    topReason() {
      const row = (this.support.reasonBuckets || [])[0];
      return row ? this.prettyReason(row.reason) : 'None';
    }
  },
  created() { this.loadData(); },
  methods: {
    formatNumber,
    prettyStep,
    prettyReason(reason) {
      if (!reason) return '-';
      return String(reason).replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
    },
    formatWhen(v) {
      return formatUkDateTime(v);
    },
    loadData() {
      this.loading = true;
      this.$onboardingTrackingService.getSupport({
        ...rangeParams(this.fromDate, this.toDate),
        size: 50
      }).then((res) => {
        this.support = (res && res.data) || {};
        this.interactions = ((this.support.interactions || {}).content) || [];
      }).finally(() => { this.loading = false; });
    }
  }
};
</script>
